module.exports = __webpack_public_path__ + "img/instruction.388c755e.gif";